module.exports = __webpack_public_path__ + "img/Glorian_Ifea_small.a59d9e7a.jpg";